import { Layer, LAYER_STYLE_TYPE } from "~utils/types/__generated/gql/graphql";
import { LayerProps } from "react-map-gl/maplibre";
import { getBubbleStyle } from "./get-bubble-style";
import { getHeatMapStyle } from "./get-heatmap-style";
import { getLineSimpleStyles } from "./get-line-style/simple-style";
import { getLineCategoryStyle } from "./get-line-style/category-style";
import { getLineQuantityStyle } from "./get-line-style/quantity-style";
import { getPointSimpleStyles } from "./get-point-style/simple-style";
import { getPointCategoryStyle } from "./get-point-style/category-style";
import { getPointQuantityStyle } from "./get-point-style/quantity-style";
import { getPolygonSimpleStyles } from "./get-polygon-style/simple-style";
import { getPolygonCategoryStyle } from "./get-polygon-style/category-style";
import { getPolygonQuantityStyle } from "./get-polygon-style/quantity-style";

export const getMaplibreStylesFromLayerConfigs = (
	layer: Layer,
): LayerProps[] => {
	switch (layer.styleType) {
		case LAYER_STYLE_TYPE.LINE_SIMPLE: {
			if (!layer.lineSimpleStyle)
				throw new Error("lineSimpleStyle is required");

			return getLineSimpleStyles(layer.lineSimpleStyle);
		}
		case LAYER_STYLE_TYPE.POINT_SIMPLE: {
			if (!layer.pointSimpleStyle)
				throw new Error("pointSimpleStyle is required");
			return getPointSimpleStyles(layer.pointSimpleStyle);
		}
		case LAYER_STYLE_TYPE.POLYGON_SIMPLE: {
			if (!layer.polygonSimpleStyle)
				throw new Error("polygonSimpleStyle is required");

			return getPolygonSimpleStyles(layer.polygonSimpleStyle);
		}
		case LAYER_STYLE_TYPE.LINE_QUANTITY: {
			if (!layer.lineQuantityStyle)
				throw new Error("lineQuantityStyle is required");

			return getLineQuantityStyle(layer.lineQuantityStyle);
		}
		case LAYER_STYLE_TYPE.POINT_QUANTITY: {
			if (!layer.pointQuantityStyle)
				throw new Error("pointQuantityStyle is required");

			return getPointQuantityStyle(layer.pointQuantityStyle);
		}
		case LAYER_STYLE_TYPE.POLYGON_QUANTITY: {
			if (!layer.polygonQuantityStyle)
				throw new Error("polygonQuantityStyle is required");

			return getPolygonQuantityStyle(layer.polygonQuantityStyle);
		}
		case LAYER_STYLE_TYPE.POLYGON_CATEGORY: {
			if (!layer.polygonCategoryStyle)
				throw new Error("polygonCategoryStyle is required");

			return getPolygonCategoryStyle(layer.polygonCategoryStyle);
		}
		case LAYER_STYLE_TYPE.LINE_CATEGORY: {
			if (!layer.lineCategoryStyle)
				throw new Error("lineCategoryStyle is required");

			return getLineCategoryStyle(layer.lineCategoryStyle);
		}
		case LAYER_STYLE_TYPE.POINT_CATEGORY: {
			if (!layer.pointCategoryStyle)
				throw new Error("pointCategoryStyle is required");

			return getPointCategoryStyle(layer.pointCategoryStyle);
		}
		case LAYER_STYLE_TYPE.BUBBLE: {
			if (!layer.bubbleStyle) throw new Error("bubbleStyle is required");

			return getBubbleStyle(layer.bubbleStyle, layer.datasetId);
		}
		case LAYER_STYLE_TYPE.HEATMAP: {
			if (!layer.heatMapStyle) throw new Error("heatMapStyle is required");

			return getHeatMapStyle(layer.heatMapStyle);
		}
		default:
			throw new Error("Unimplemented style types");
	}
};
